import type { SilkAuthConfig } from '@/api'

let cached: SilkAuthConfig | null = null
let inflight: Promise<SilkAuthConfig> | null = null

export function getAuthConfigCache(): SilkAuthConfig | null {
  return cached
}

export function getAuthConfigInflight(): Promise<SilkAuthConfig> | null {
  return inflight
}

export function setAuthConfigCache(next: SilkAuthConfig | null): void {
  cached = next
}

export function setAuthConfigInflight(next: Promise<SilkAuthConfig> | null): void {
  inflight = next
}

export function clearAuthConfigCache(): void {
  cached = null
  inflight = null
}

export const AUTH_CONFIG_INVALIDATE_EVENT = 'silkreels:auth-config-invalidate'

export function notifyAuthConfigInvalidate(): void {
  if (typeof window === 'undefined') return
  clearAuthConfigCache()
  window.dispatchEvent(new CustomEvent(AUTH_CONFIG_INVALIDATE_EVENT))
}
